export const SET_CAN_ACCESS_SCHEDULE_SCREEN = 'dailyAgenda/set-can-access-schedule-screen';

export function setCanAccessScheduleScreen(canAccess: any) {
  return { type: SET_CAN_ACCESS_SCHEDULE_SCREEN, canAccess };
}
